<template>
    <div class="detection-config-collapse">
      <pt-sub-title title="检测项计算配置">
          <el-button slot="line" size="mini" type="primary" class="addButton" v-if="showButton && !detectionEngineDefault" @click="goNew">新增配置</el-button>
      </pt-sub-title>
      <div v-for="(item, index) in configs" :key="index" class="collapseBox">
        <el-collapse >
          <el-collapse-item  :name="index">
              <template slot="title">
                  {{'配置ID：'+item.id}}
                  <span style="margin-right:18px;"></span>
                  {{'实验室检测平台：'+item.sequencingTechnology}}
                  <span style="margin-right:18px;"></span>
                  {{'计算模型：'+formatConfigType(item.type)}}
                  <span style="margin-right:18px;"></span>
                  {{'适用性别：'+formatConfigSex(item.gender)}}
                  <span style="margin-right:18px;"></span>
                  {{'位点数量：'+item.sitesCount}}
              </template>
              <!-- <div v-html="item.params"></div> -->
              <!-- 参数表格，不同模型对应不同表格 -->
              <template >
                  <!-- <template v-if="item.type==='CAUSAL_AUTO'">
                    <config-params-table :key="index" v-for="(e,index) in item.params" :tableData="e.causalGenes" :configType="item.type" v-loading="tabLoading"></config-params-table>
                  </template>
                  <template v-else>
                    <config-params-table v-if="item.params" :tableData="item.params" :configType="item.type" v-loading="tabLoading"></config-params-table>
                  </template> -->
                  <config-params-table :configId="item.id" :configType="item.type" v-loading="tabLoading"></config-params-table>
              </template>
          </el-collapse-item>
        </el-collapse>
        <el-button v-if="showButton && !item.engineDefault" type="text" @click="goEdit(item)" class="editText">重新导入</el-button>
        <el-button v-if="showButton && !item.engineDefault" type="text" @click="goDelete(item)" class="editText">删除</el-button>
      </div>
      <!-- 导入参数 -->
			<import-config-params ref="imprtDialog" :dialogTitle="dialogTitle" :dialogConfigVisible="showDialog" @update="update" :detectionCategory="category" @updateConfig="getConfig"></import-config-params>
    </div>
</template>

<script>
import { formatConfigSex, formatConfigType } from 'enumeration/lab-order.js'
import configParamsTable from 'cps/gene-product/selector/config-params-table'
import importConfigParams from 'cps/gene-product/selector/import-config-params'
export default {
  data () {
    return {
      tabLoading: false,
      configs: [],
      dialogTitle: '新增配置',
      showDialog: false
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: ''
    },
    detectionEngineDefault: {
      type: Boolean,
      default: false
    }
  },
  components: {
    configParamsTable,
    importConfigParams
  },
  watch: {
    id (val) {
      this.getConfig()
    }
  },
  methods: {
    formatConfigSex,
    formatConfigType,
    getConfig () {
      this.tabLoading = true
      this.$store.dispatch('getDetectionConfig', this.id).then((response) => {
        this.tabLoading = false
        console.log('response-----', response.data)
        if (response.data) {
          this.configs = response.data
        }
      })
        .catch((error) => {
          this.tabLoading = false
          console.log(error)
        })
    },
    update (val) {
      this.showDialog = val
    },
    goEdit (data) {
      this.dialogTitle = '重新导入配置'
      this.showDialog = true
      this.$refs.imprtDialog.reset()
    },
    goNew () {
      this.dialogTitle = '新增配置'
      this.showDialog = true
      console.log(this.$refs)
      this.$refs.imprtDialog.reset()
    },
    goDelete (data) {
      this.$confirm('确定要删除"计算模型:' + formatConfigType(data.type) + ',位点数量:' + data.sitesCount + '"的配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('updateLoading', true)
        this.$store.dispatch('deleteDetectionConfig', data.id).then(res => {
          this.$message.success('删除成功！')
          this.$emit('updateLoading', false)
          this.getConfig()
        }).catch(err => {
          this.$emit('updateLoading', false)
          this.$message.erroe(err)
        })
      })
    }
  },
  created () {
    if (this.id) {
      this.getConfig()
    }
  }
}
</script>

<style lang="less">
.detection-config-collapse{
  .collapseBox{
    display: flex;
    >.el-collapse{
      flex:1;
      margin-right: 10px;
      width: 80%;
    }
  }
  .addButton{
    margin:0 0 0px 20px;
  }
	.editText{
    margin-top:-20px;
	}
  .el-collapse{
    margin-bottom: 20px;
    margin-left: 20px;
    padding-left: 20px;
    border: 0.01rem solid #ebeef5;
	}
}
</style>
